module.exports = __webpack_public_path__ + "static/media/SKODANext-Black.e5089016.ttf";